import ProgressBar from '@ramonak/react-progress-bar';
import React from 'react';
import pause from '../../../../assets/pause.svg';
import stylesTable from '../../../../components/reusable/Tables/Tables.module.css';
import { parceBudget, parcePercentage } from '../../../../helpers/parceBudget';
import Table from '../../Table';
import { formater } from '../DashboardTableRows/functions';
import ComparisonChangeValue from '../ComparisonChangeValue';

const ClientPerformanceTable = ({
  data,

  isLoading,
  isDefaultCurrentCycleView,
  isShowComparison,

  type,
  handleClickClient,
}) => {
  const columns = [
    {
      title: 'Client',
      dataIndex: 'client_name',
      key: 'client_name',
      fixed: 'left',
      sorter: true,
      className: `${stylesTable.tdNoWidth}`,
      style: ({ row_type }, _) => ({
        ...(row_type === 'total'
          ? { color: '#111A39', cursor: 'not-allowed' }
          : { color: '#1649EC', cursor: 'pointer' }),
      }),
      render: ({ row_type, client_name }, _) => {
        return row_type === 'total' ? 'Total' : client_name;
      },
      onClickDataCell: (record, _) => {
        if (handleClickClient) handleClickClient(record);
      },
    },
    {
      title: 'Spend',
      dataIndex: 'spend',
      key: 'spend',
      sorter: true,
      className: `${stylesTable.tdNoWidth}`,
      render: ({
        spend,
        budget_amount,
        currency,
        trend,
        status,
        previous_period_spend_change,
        row_type,
      }) => {
        return (
          <div className={`${stylesTable.comparisonContainer}`}>
            {isDefaultCurrentCycleView ? (
              <div className={stylesTable.progressBarContainer}>
                <ProgressBar
                  completed={spend}
                  maxCompleted={budget_amount}
                  customLabel={parceBudget(spend, currency, 0)}
                  borderRadius="0"
                  height="3rem"
                  bgColor={formater('primaryColor', trend, type)}
                  baseBgColor={formater('secondaryColor', trend, type)}
                  labelAlignment="left"
                  labelColor="var(--white)"
                  labelSize="1.2rem"
                  labelClassName={stylesTable.progressBarLabel}
                  width="13rem"
                />
                {status === 'paused' && (
                  <img className={stylesTable.pause} alt="pause" src={pause} />
                )}
              </div>
            ) : (
              <>{parceBudget(spend, currency, 0)}</>
            )}
            {isShowComparison && row_type !== 'total' && (
              <ComparisonChangeValue
                noColor
                value={previous_period_spend_change}
              />
            )}
          </div>
        );
      },
    },
    {
      title: 'Conversions',
      dataIndex: 'conversions',
      key: 'conversions',
      sorter: true,
      className: `${stylesTable.tdNoWidth}`,
      render: (
        { conversions, previous_period_conversions_change, row_type },
        _,
      ) => {
        return (
          <div className={`${stylesTable.comparisonContainer}`}>
            <span>{parceBudget(conversions, '', 0)}</span>
            {isShowComparison && row_type !== 'total' && (
              <ComparisonChangeValue
                value={previous_period_conversions_change}
              />
            )}
          </div>
        );
      },
    },
    {
      title: 'CPA',
      dataIndex: 'cpa',
      key: 'cpa',
      sorter: true,
      className: `${stylesTable.tdNoWidth}`,
      render: ({ cpa, currency, previous_period_cpa_change, row_type }, _) => {
        return (
          <div className={`${stylesTable.comparisonContainer}`}>
            <span>{parceBudget(cpa, currency)}</span>
            {isShowComparison && row_type !== 'total' && (
              <ComparisonChangeValue value={previous_period_cpa_change} />
            )}
          </div>
        );
      },
    },
    {
      title: 'Revenue',
      dataIndex: 'revenue',
      key: 'revenue',
      sorter: true,
      className: `${stylesTable.tdNoWidth}`,
      render: (
        { revenue, currency, previous_period_revenue_change, row_type },
        _,
      ) => {
        return (
          <div className={`${stylesTable.comparisonContainer}`}>
            <span>{parceBudget(revenue, currency)}</span>
            {isShowComparison && row_type !== 'total' && (
              <ComparisonChangeValue value={previous_period_revenue_change} />
            )}
          </div>
        );
      },
    },
    {
      title: 'ROAS',
      dataIndex: 'roas',
      key: 'roas',
      sorter: true,
      className: `${stylesTable.tdNoWidth}`,
      render: ({ roas, row_type, previous_period_roas_change }, _) => {
        return (
          <div className={`${stylesTable.comparisonContainer}`}>
            <span>{parcePercentage(roas)}</span>
            {isShowComparison && row_type !== 'total' && (
              <ComparisonChangeValue value={previous_period_roas_change} />
            )}
          </div>
        );
      },
    },
    {
      title: '7 Day CPA',
      dataIndex: 'seven_days_cpa',
      key: 'seven_days_cpa',
      sorter: true,
      className: `${stylesTable.tdNoWidth}`,
      render: ({ seven_days_cpa, currency }, _) => {
        return parceBudget(seven_days_cpa, currency);
      },
    },
    {
      title: '7 Day ROAS',
      dataIndex: 'seven_days_roas',
      key: 'seven_days_roas',
      sorter: true,
      className: `${stylesTable.tdNoWidth}`,
      render: ({ seven_days_roas }, _) => {
        return parcePercentage(seven_days_roas);
      },
    },
    {
      title: 'Forecast Conv.',
      dataIndex: 'forecast_conversions',
      sorter: true,
      className: `${stylesTable.tdNoWidth}`,
      render: ({ forecast_conversions }, _) => {
        return parceBudget(forecast_conversions, '', 0);
      },
    },
    {
      title: 'Forecast Revenue',
      dataIndex: 'forecast_revenue',
      sorter: true,
      className: `${stylesTable.tdNoWidth}`,
      render: ({ forecast_revenue, currency }, _) => {
        return parceBudget(forecast_revenue, currency);
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      isLoading={isLoading}
      unSortLastElement
      rowClassNameProvider={record => {
        const baseClassName = stylesTable.tr;
        const additionalClassName =
          record?.row_type === 'total' ? stylesTable.trTotal : '';

        return `${baseClassName} ${additionalClassName}`;
      }}
    />
  );
};

export default ClientPerformanceTable;
